var Env = {
  ua: navigator.userAgent,
  isCGApp(){
    return /TheCover/i.test(this.ua);
  },
  isIos(){
    return /ios|iphone|ipad/i.test(this.ua);
  },
  isAndroid(){
    return /android/i.test(this.ua);
  },
  isWeixin(){
    return /MicroMessenger/i.test(this.ua);
  },
  isQQ: function () {
    return /qq/i.test(this.ua);
  },
}

function getQuery(){
  var str = window.location.search.substr(1), temp, o = {};
  str.split('&').map(function(item){
      temp = item.split('=');
      o[temp[0]] = temp[1];
  });
  return o;
}

export {
  Env,
  getQuery
}